import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useSettings } from '../hooks/useSettings';
import Header from './Header';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';

// Force HMR update on file change
if (import.meta.hot) {
  import.meta.hot.accept();
}

export default function Layout() {
  const { settings } = useSettings();
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const root = document.documentElement;
    if (settings.theme === 'dark') {
      root.classList.add('dark');
      setIsDark(true);
    } else if (settings.theme === 'light') {
      root.classList.remove('dark');
      setIsDark(false);
    } else {
      // Auto mode - check system preference
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      if (prefersDark) {
        root.classList.add('dark');
        setIsDark(true);
      } else {
        root.classList.remove('dark');
        setIsDark(false);
      }
    }
  }, [settings.theme]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-black">
      <Header />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 p-4 md:p-6 lg:p-8 pb-24 md:pb-6">
          <Outlet />
        </main>
      </div>
      <MobileNav />
    </div>
  );
}